/**
 * Decode the auth token payload.
 * @param {*} token The JWT token.
 * @return {object} The token payload or undefined when error.
 */
export function getTokenPayload(token) {
  const parts = token.split('.');

  if (parts.length === 3) {
    const payload = urlBase64Decode(parts[1]);
    if (!isTokenExpired(payload)) {
      return payload;
    }
  }

  return undefined;
}

/**
 * return true if auth token has expired.
 * @param {object} payload The payload object
 * @return {boolean} Return true if token has expired, else false
 */
export function isTokenExpired(payload) {
  if (typeof payload.exp === 'undefined') {
    // No expiration date
    return false;
  }
  // The 0 here is the key, which sets the date to the epoch (01/01/1970)
  const d = new Date(0);
  d.setUTCSeconds(payload.exp);
  // True if token expired, else false
  return d.valueOf() <= new Date().valueOf();
}

/**
 * Decode the token payload string and convert it to a JS object
 * @param {string} str The JWT payload string
 * @return {object} The token payload object or undefined if error.
 */
function urlBase64Decode(str) {
  const data = Buffer.from(base64urlUnescape(str), 'base64').toString();
  try {
    return JSON.parse(data);
  } catch (e) {
    return undefined;
  }
}

/**
 * Unescape base64 string
 * @param {string} str The input string
 * @return {string} The unescaped string
 */
function base64urlUnescape(str) {
  str += new Array(5 - str.length % 4).join('=');
  return str.replace(/\-/g, '+').replace(/_/g, '/');
}
